import { useMemo } from 'react';

import { createFormatters } from '@nucleus-commerce/i18n';
import { useFormat } from '@nucleus-commerce/i18n/react';

/** Formatters on the schedule's own clock: run times read in the zone the cadence counts in. */
export function useScheduleFormat(timeZone: string) {
  const { locale } = useFormat();
  return useMemo(() => createFormatters({ locale, timeZone }), [locale, timeZone]);
}
